import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";
import { consultIntegrations } from "../../../services/api/Integrations/listIntegrations";  
import { consultRegisteredIntegrations } from "../../../services/api/Integrations/listRegisteredIntegrations";
import use123zapStore from "../../../context/123zapStore";
import { INTEGRATIONS_CONFIG } from "../../../shared/constants/integrations";

function normalizeValue(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, "");
}

export function useIntegrationsOptions(onIntegrationClick) {
  const navigate = useNavigate();
  const setIntegrations = use123zapStore((state) => state.setIntegrations); 
  const integrations = use123zapStore((state) => state.integrations); 
  const [registeredItems, setRegisteredItems] = useState([]);
  const [loadingRegistered, setLoadingRegistered] = useState(false);

  useEffect(() => {
    if (!integrations || integrations.length === 0) {
      consultIntegrations()  
        .then((response) => {
          setIntegrations(response.data); 
        })
        .catch((error) => {
          console.error("Erro ao carregar integrações:", error);
        });
    }
  }, [integrations, setIntegrations]);

  const loadRegisteredIntegrations = useCallback(() => {
    setLoadingRegistered(true);

    consultRegisteredIntegrations()
      .then((response) => {
        const payload = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
            ? response.data
            : [];
        setRegisteredItems(payload);
      })
      .catch((error) => {
        console.error("Erro ao carregar integrações registradas:", error);
        setRegisteredItems([]);
      })
      .finally(() => setLoadingRegistered(false));
  }, []);

  useEffect(() => {
    loadRegisteredIntegrations();
  }, [loadRegisteredIntegrations]);

  const registeredKeys = useMemo(() => {
    const keySet = new Set();

    registeredItems.forEach((item) => {
      [
        item?.integration_id,
        item?.erp_integration_id,
        item?.integration_key,
        item?.integration_slug,
        item?.integration_title,
        item?.integration_name,
        item?.title,
        item?.name,
      ]
        .filter(Boolean)
        .forEach((value) => keySet.add(normalizeValue(value)));
    });

    return keySet;
  }, [registeredItems]);

  const integrationsList = INTEGRATIONS_CONFIG.map((integration) => {
    const normalizedTitle = normalizeValue(integration.title);
    const normalizedKey = normalizeValue(integration.key);
    const ssoticaAliasMatch =
      normalizedTitle === "ssotica" &&
      (registeredKeys.has("ssotica") || registeredKeys.has("sotica"));

    const hasCredential =
      registeredKeys.has(normalizeValue(integration.id)) ||
      registeredKeys.has(normalizedKey) ||
      registeredKeys.has(normalizedTitle) ||
      ssoticaAliasMatch;

    return ({
    ...integration,
    alreadyPaid: true,
    hasCredential,
    handleClick: () => {
      localStorage.setItem("integration_id", integration.id); 
      localStorage.setItem("integration_title", integration.title);
      if (onIntegrationClick) {
        onIntegrationClick(integration);
        return;
      }
      navigate("/integrações/adicionar");
    },
  })}).sort((a, b) =>
    String(a.title || "").localeCompare(String(b.title || ""), "pt-BR", {
      sensitivity: "base",
    }),
  );


  return {
    integrationsList: [...integrationsList],
    loadingRegistered,
    refresh: loadRegisteredIntegrations,
  };
}
